import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import Hero from "src/components/Hero/Hero";
import { Row, Col } from "react-bootstrap";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";
import TitleSection from "src/components/TitleSection/TitleSection";
import SubTitleSection from "src/components/SubTitleSection/SubTitleSection";

const WinningWednesday = () => {
  const { t, i18n } = useTranslation();
  const table = t("winningWednesday.freePlayTable", { returnObjects: true });
  return (
    <WinningWednesdayDiv>
      <Hero
        bgImage={`promotions/gaming-machines/winning-wednesday/winning-wedneaday-hero-image-2400x800px.jpg`}
        buttonSettings={null}
        image={`promotions/gaming-machines/winning-wednesday/winning-wedneaday-2400x2400px-${i18n.language}.png`}
        darkenBg={0.5}
        title={t("winningWednesday.hero.desc")}
        titleAs="h2"
      />
      <MainContentDiv>
        <TitleSection
          as={"h3"}
          title={t("winningWednesday.content.title")}
          text={t("winningWednesday.content.desc")}
        />
        <container-div>
          <Row className="g-5 mt-0 align-items-center justify-content-center flex-column-reverse flex-md-row">
            <Col md={5} xs={12}>
              <PromoContent>
                <ReactMarkdown>{t("winningWednesday.howToWin")}</ReactMarkdown>
                <Table>
                  <thead>
                    <tr>
                      <th>{table.header[0]}</th>
                      <th>{table.header[1]}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {table.rows.map((row, idx) => (
                      <tr key={idx}>
                        <td>{row[0]}</td>
                        <td>{row[1]}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </PromoContent>
            </Col>
            <Col md={5} xs={12}>
              <ResponsiveImage
                src={`promotions/gaming-machines/winning-wednesday/gaming-winning-wednesdays.jpg`}
                alt="Gaming Winning Wednesdays"
              />
            </Col>
          </Row>
          <Row className="g-5 mt-0 mt-md-4 align-items-center justify-content-center">
            <Col md={5} xs={12}>
              <ResponsiveImage
                src="promotions/gaming-machines/winning-wednesday/The-rail-winning-wednesdays.jpg"
                alt="The Rail Winning Wednesdays"
              />
            </Col>
            <Col md={5} xs={12}>
              <PromoContent>
                <ReactMarkdown>{t("winningWednesday.theRail")}</ReactMarkdown>
              </PromoContent>
            </Col>
          </Row>
          <Row className=" mt-4 p-3">
            {/* <ReactMarkdown>{t("winningWednesday.theRail")}</ReactMarkdown> */}
            <SubTitleSection
              as={"h3"}
              text={t("winningWednesday.midweekWinner")}
              borderColor="#02c5cb"
            />
          </Row>
        </container-div>
      </MainContentDiv>
    </WinningWednesdayDiv>
  );
};

const WinningWednesdayDiv = styled.div`
  width: 100%;
  background: var(--lightblack);
  color: var(--white);
  .hero_text_container {
    background-color: none;
    background: #02c5cb !important;
    h2 {
      font-size: 1.7rem !important;
      text-shadow: none;
    }
  }
  .title-section {
    h3 {
      margin-bottom: 24px;
    }
    span {
      display: none;
    }
    @media (max-width: 768px) {
      h3 {
        font-size: 1.8rem;
      }
    }
  }
  .subtitle-section {
    h3 {
      border-left: 4px solid #02c5cb;
    }
  }
`;

const MainContentDiv = styled.div`
  width: 100%;
  padding: 40px 0;
`;

const PromoContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  h4 {
    color: #02c5cb;
    font-weight: bold;
  }
  @media (max-width: 768px) {
    h4 {
      font-size: 1.2rem;
    }
  }
`;
const Table = styled.table`
  width: 100%;
  max-width: 100%;
  margin: 20px 0px 40px 0px;
  background: #fff;
  border: 1px solid #ddd;
  border-spacing: 0;
  border-collapse: collapse;
  & > thead {
    & > tr {
      & > th {
        border: 1px solid #ddd;
        border-bottom: none;
        padding: 8px;
        line-height: 1.42857143;
        text-align: center;
        background: #131619;
        color: #fff;
        border-radius: 0px;
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 0.5px;
        text-align: center;
      }
    }
  }
  & > tbody {
    & > tr {
      &:hover {
        background-color: rgba(0, 0, 0, 0.1);
      }
      & > td {
        text-align: center;
        border: 1px solid #ddd;
        padding: 8px;
        line-height: 1.42857143;
        vertical-align: top;
        font-size: 14px;
        color: #333;
      }
    }
  }
`;
export default WinningWednesday;
